import { IReward } from './IReward';
import { Reward } from './Reward';

export class AtmReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.AtmReward';

	public static readonly NAME: string = 'ATM Fee Refunds';

	transactionCountLimit: number | null = null;

	maxRefundAmountPerTransaction: number | null = null;

	maxTotalRefundAmountPerAccount: number | null = null;

	refundTerminalFee: boolean = false;

	refundForeignAtmUsageFee: boolean = false;

	constructor(reward?: IReward) {
	  super(AtmReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.transactionCountLimit = (reward as any).transactionCountLimit;
	    this.maxRefundAmountPerTransaction = (reward as any).maxRefundAmountPerTransaction;
	    this.maxTotalRefundAmountPerAccount = (reward as any).maxTotalRefundAmountPerAccount;
	    this.refundTerminalFee = (reward as any).refundTerminalFee;
	    this.refundForeignAtmUsageFee = (reward as any).refundForeignAtmUsageFee;
	  }
	}

	getDescription(): string {
	  if (!this.maxRefundAmountPerTransaction && !this.maxTotalRefundAmountPerAccount
			&& !this.transactionCountLimit) {
	    return 'Unlimited ATM Refunds';
	  } if (this.maxTotalRefundAmountPerAccount) {
	    if (!this.maxRefundAmountPerTransaction && !this.transactionCountLimit) {
	      return `ATM Refunds up to $${this.maxTotalRefundAmountPerAccount} total.`;
	    } if (!this.maxRefundAmountPerTransaction) {
	      return `Up to ${this.transactionCountLimit} ATM fee refunds up to $${this.maxTotalRefundAmountPerAccount} total.`;
	    } if (!this.transactionCountLimit) {
	      return `ATM fee refunds of up to $${this.maxRefundAmountPerTransaction}, $${this.maxTotalRefundAmountPerAccount} total.`;
	    }
	    return `Up to ${this.transactionCountLimit} ATM fee refunds of up to $${
	      this.maxRefundAmountPerTransaction}, $${this.maxTotalRefundAmountPerAccount} total.`;
	  }
	  if (!this.maxRefundAmountPerTransaction) {
	    return `Up to ${this.transactionCountLimit} ATM fee refunds.`;
	  } if (!this.transactionCountLimit) {
	    return `ATM fee refunds of up to $${this.maxRefundAmountPerTransaction}.`;
	  }
	  return `Up to ${this.transactionCountLimit} ATM fee refunds of up to $${
	    this.maxRefundAmountPerTransaction} each.`;
	}

	clone(): IReward {
	  const clone = new AtmReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default AtmReward;
